import styled from 'styled-components';
import { breakpoints } from '../../../common/mediaQuery';

export const FilterSection = styled.div`
  flex-direction: column;
  margin-top: 24px;

  @media screen and (max-width: ${breakpoints.mobile}px) {
    margin-top: 16px;
  }
`;
